import React from "react";

import { useInsightsContext } from "../../Context/InsightsContext";
import { useRoomInsightsContext } from "../../Context/Room/Overview/RoomInsightsContext";
import { useUtilizationInsightsContext } from "../../Context/Room/Utilization/UtilizationContext";
import { useBehaviourInsightsContext } from "../../Context/Room/Behaviour/BehaviourContext";
import { InsightsLoaderModalController } from "./InsightsLoaderModalController";

interface Props {
  onCancel: () => void;
}

export const RoomInsightsLoaderModal = ({ onCancel }: Props) => {
  const { loadingGeneralSettings } = useInsightsContext();
  const {
    loadingGeneralStats,
    loadingRooms,
    loadingRange,
    loadingRoomHistory,
  } = useRoomInsightsContext();
  const { loading: loadingUtilization, loadingDensity } =
    useUtilizationInsightsContext();
  const { loading: loadingBehaviour, loadingSankey } =
    useBehaviourInsightsContext();

  const isLoading =
    loadingGeneralSettings ||
    loadingGeneralStats ||
    loadingRooms ||
    loadingRange ||
    loadingRoomHistory ||
    loadingUtilization ||
    loadingDensity ||
    loadingBehaviour ||
    loadingSankey;

  return (
    <InsightsLoaderModalController
      isLoading={isLoading}
      insightsType="rooms"
      onCancel={onCancel}
    />
  );
};
